module.exports = "/fonts/Cabin-Italic.ttf";